import { ThunkResult } from '../../../store/configureStore'
import { Actions } from '../user-login/actionCreators'
import { AuthenticationGateway } from '../../gateways/authenticationGateway.interface'

export const logoutUser: ThunkResult<Promise<void>> =
  async (dispatch, _getState, { authenticationGateway }: { authenticationGateway: AuthenticationGateway }) => {
    dispatch(Actions.userLoggedOut())
  }
